import { Utils } from 'cc-common';
import { BaseParameterDto } from '../../_models/base-parameter-dto';

export class SharedWorkspaceParametersDto extends BaseParameterDto {
    categoryCode: string;
    isSystemType: boolean;

    getQueryString(): string {
        const tokens = [`clearCache=${this.clearCache}`];
        if (Utils.notNullOrEmpty(this.categoryCode)) {
            tokens.push(`categoryCode=${this.categoryCode}`);
        }
        if (Utils.notNullAndDefined(this.isSystemType)) {
            tokens.push(`isSystemType=${this.isSystemType}`);
        }
        return tokens.join('&');
    }
}
